<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-consulta">Trámites</router-link> >
            Trámite {{ p_idTramite }}: Atenciones con observaciones
          </div>
        </div>
      </div>
    </div>

    <hr />

    <!-- Instrucciones -->
<div class="alert alert-info py-2 px-3 mb-3" role="alert">
  <strong>Instrucciones:</strong>
  Seleccione el <strong>Periodo</strong> y el <strong>Tipo de Observación</strong> para mostrar los datos.
  Use el filtro <strong>Estado</strong> para ver todos los registros, solo los <strong>respondidos</strong> o solo los <strong>pendientes sin respuesta</strong>.
  Puede ordenar las columnas haciendo clic en los encabezados y filtrar por cualquier campo usando las cajas de texto bajo los encabezados.
</div>

    <!-- Filtros -->
<div class="container mb-4">
  <div class="row g-3 align-items-end">

    <div class="col-3">
      <label class="form-label fw-bold">Periodo</label>
      <select class="form-select" v-model="cargaSeleccionada"
        @change="getDataPaginaTodos(1)">
        <option disabled value="">Seleccione ...</option>
        <option v-for="carga in cargas" :key="carga.idCarga" :value="carga.idCarga">
          {{ getFormattedDate(carga.fechaDesde) }}
          {{ carga.tipoCarga === 'M' ? 'Mensual' : carga.tipoCarga === 'S' ? 'Semanal' : carga.tipoCarga === 'A' ? 'Autorización' : 'Desconocido' }}
        </option>
      </select>
    </div>

    <div class="col-3">
      <label class="form-label fw-bold">Tipo de observación</label>
      <select class="form-select" v-model="tipoObsSeleccionado"
        @change="getDataPaginaTodos(1)">
        <option disabled value="">Seleccione ...</option>
        <option value="M">Auditoría Médica</option>
        <option value="D">Gestión Documental</option>
      </select>
    </div>

<div class="col-3">
  <label class="form-label fw-bold mb-1">Estado</label>
  <select class="form-select" v-model="filtroEstado" @change="getDataPaginaTodos(1)">
    <option value="todos">Todos</option>
    <option value="respondidos">Respondidos</option>
    <option value="pendientes">Sin respuesta</option>
  </select>
</div>
<div class="col-3">
  <label class="form-label fw-bold mb-1">Justificado</label>
  <select class="form-select" v-model="filtroRevisado" @change="getDataPaginaTodos(1)">
    <option value="todos">Todos</option>
    <option value="1">Justificado</option>
    <option value="0">No justificado</option>
  </select>
</div>
  </div>
</div>

<div class="d-flex justify-content-between align-items-center mb-2" v-if="planillas.length > 0">
  <!-- Registros por página -->
  <div class="d-flex align-items-center gap-2">
    <label class="form-label mb-0 small fw-bold">Mostrar</label>
    <select v-model.number="elementosPorPagina" class="form-select form-select-sm"
      style="width: 75px;" @change="aplicarPaginacion(1)">
      <option :value="10">10</option>
      <option :value="25">25</option>
      <option :value="50">50</option>
      <option :value="100">100</option>
    </select>
    <span class="small text-muted">registros</span>
    <!-- Botón exportar -->
<button class="btn btn-outline-success btn-sm d-flex align-items-center gap-1" @click="exportarVistaActual">
  <span class="material-symbols-outlined" style="font-size:18px">download</span>
  Exportar vista actual
</button>
<button class="btn btn-success btn-sm d-flex align-items-center gap-1" @click="exportarTodasObservaciones" :disabled="exportandoTodas">
  <span class="material-symbols-outlined" style="font-size:18px">download</span>
  {{ exportandoTodas ? 'Generando...' : 'Exportar todas las observaciones del trámite' }}
</button>
  </div>
</div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="planillas.length > 0">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
<thead class="table-dark">
  <tr>
    <th class="th-sort" @click="ordenarPor('numero')">
      Número <span>{{ iconOrden('numero') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('codigoElemento')">
      Código <span>{{ iconOrden('codigoElemento') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('observacionEstandar')">
      Observación estándar <span>{{ iconOrden('observacionEstandar') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('observacionComplementaria')">
      Observación complementaria <span>{{ iconOrden('observacionComplementaria') }}</span>
    </th>
    <th>Acciones</th>
  </tr>
  <!-- Fila de filtros -->
<tr>
  <th>
    <input v-model="filtros.numero"
      @input="guardarFiltrosColumna"
      class="form-control form-control-sm" placeholder="Filtrar..." />
  </th>
  <th>
    <input v-model="filtros.codigoElemento"
      @input="guardarFiltrosColumna"
      class="form-control form-control-sm" placeholder="Filtrar..." />
  </th>
  <th>
    <input v-model="filtros.observacionEstandar"
      @input="guardarFiltrosColumna"
      class="form-control form-control-sm" placeholder="Filtrar..." />
  </th>
  <th>
    <input v-model="filtros.observacionComplementaria"
      @input="guardarFiltrosColumna"
      class="form-control form-control-sm" placeholder="Filtrar..." />
  </th>
  <th>
    <button class="btn btn-outline-light btn-sm w-100" @click="limpiarFiltros" title="Limpiar filtros">
      <span class="material-symbols-outlined" style="font-size:16px">filter_alt_off</span>
    </button>
  </th>
</tr>
</thead>
        <tbody>
          <tr v-for="item in datosPaginados" :key="item.idVwObservaciones">
            <td>
              <span v-if="!item.idRespuesta" class="badge bg-danger">{{ item.numero }}</span>
              <span v-else>{{ item.numero }}</span>
            </td>
            <td>
              <span v-if="!item.idRespuesta && item.codigoElemento" class="badge bg-danger">
                {{ item.codigoElemento }}
              </span>
              <span v-else>{{ item.codigoElemento }}</span>
            </td>
            <td>{{ item.observacionEstandar }}</td>
            <td>{{ item.observacionComplementaria }}</td>
            <td>
              <button @click="verObservaciones(item)" class="btn btn-success btn-sm">
                <span class="material-symbols-outlined" style="font-size: 18px; vertical-align: middle;">
                  visibility
                </span>
                Ver
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="5" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ planillas.length }} registros
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="planillas.length === 0 && cargaSeleccionada && tipoObsSeleccionado"
      class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="planillas.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ planillas.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage()">‹</a>
          </li>
          <li v-for="pagina in paginasVisibles" :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }">
            <a class="page-link" href="#"
              @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)">
              {{ pagina }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage()">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <Footer />
  </div>
</template>

<script>
//import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import * as XLSX from "xlsx";
import Swal from 'sweetalert2';

export default {
  components: { Layout, Footer },
  data() {
    return {
      planillas: [],
      datosPaginados: [],
      elementosPorPagina: 10,
      paginaActual: 1,
      tipoObsSeleccionado: "",
      p_idTramite: 0,
      p_idUsuario: 0,
      cargas: [],
      cargaSeleccionada: "",
      filtroEstado: 'todos',
      filtroRevisado: 'todos',
      // Ordenamiento
      campoOrden: 'numero',
      ascendente: true,
      exportandoTodas: false,
filtros: {
  numero: '',
  codigoElemento: '',
  observacionEstandar: '',
  observacionComplementaria: '',
},
    };
  },
  computed: {
planillasOrdenadas() {
  const campo = this.campoOrden;
  const f = this.filtros;
  const filtradas = this.planillas.filter(item => {
    return (
      String(item.numero ?? '').toLowerCase().includes(f.numero.toLowerCase()) &&
      String(item.codigoElemento ?? '').toLowerCase().includes(f.codigoElemento.toLowerCase()) &&
      String(item.observacionEstandar ?? '').toLowerCase().includes(f.observacionEstandar.toLowerCase()) &&
      String(item.observacionComplementaria ?? '').toLowerCase().includes(f.observacionComplementaria.toLowerCase())
    );
  });
  return filtradas.sort((a, b) => {
    let va = a[campo] ?? '';
    let vb = b[campo] ?? '';

    // Ordenamiento numérico para el campo numero
    if (campo === 'numero') {
      const na = parseFloat(va);
      const nb = parseFloat(vb);
      if (!isNaN(na) && !isNaN(nb)) {
        return this.ascendente ? na - nb : nb - na;
      }
    }

    // Ordenamiento alfabético para el resto
    const cmp = String(va).localeCompare(String(vb), 'es');
    return this.ascendente ? cmp : -cmp;
  });
},
    paginasVisibles() {
      const total = this.totalPaginas(), actual = this.paginaActual, delta = 2;
      const rango = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2) rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },
watch: {
  planillasOrdenadas() {
    this.aplicarPaginacion(1);
  }
},
  mounted() {
    window.sessionStorage.removeItem("planillaSeleccionada");
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarSemanasDelMes();
    if (window.sessionStorage.getItem("cargaSeleccionada"))
      this.cargaSeleccionada = window.sessionStorage.getItem("cargaSeleccionada");
    if (window.sessionStorage.getItem("tipoObsSeleccionado"))
      this.tipoObsSeleccionado = window.sessionStorage.getItem("tipoObsSeleccionado");
    if (window.sessionStorage.getItem("filtroEstado"))
      this.filtroEstado = window.sessionStorage.getItem("filtroEstado");
    if (window.sessionStorage.getItem("filtrosColumna"))
      this.filtros = JSON.parse(window.sessionStorage.getItem("filtrosColumna"));
    if (window.sessionStorage.getItem("filtroRevisado"))
      this.filtroRevisado = window.sessionStorage.getItem("filtroRevisado");
    this.getDataPaginaTodos(this.paginaActual);	
  },
  methods: {
    // Ordenamiento
    ordenarPor(campo) {
      this.ascendente = campo === this.campoOrden ? !this.ascendente : true;
      this.campoOrden = campo;
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },
    // Paginación
    totalPaginas() {
      return Math.max(1, Math.ceil(this.planillasOrdenadas.length / this.elementosPorPagina));
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual = noPagina;
      const ini = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.planillasOrdenadas.slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },
    isActive(noPagina) {
      return noPagina === this.paginaActual ? 'active' : '';
    },
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },
    // Datos
async getDataPaginaTodos(noPagina) {
  if (!this.cargaSeleccionada || !this.tipoObsSeleccionado) return;

  const endpoint = this.filtroEstado === 'pendientes'
    ? `/vwobservaciones/buscar-pendientes`
    : `/vwobservaciones/buscar-todos`;

  try {
    const response = await api.get(
      `${endpoint}?idTramite=${this.p_idTramite}&idCarga=${this.cargaSeleccionada}&tipo=${this.tipoObsSeleccionado}`
    );
    let data = response.data.reverse();

    if (this.filtroEstado === 'respondidos') {
      data = data.filter(item => item.idRespuesta);
    }

if (this.filtroRevisado === '1') {
  data = data.filter(item => item.revisado === 1);
}
if (this.filtroRevisado === '0') {
  data = data.filter(item => !item.revisado || item.revisado === 0);
}

    this.planillas = data;
    this.aplicarPaginacion(noPagina);
  } catch (error) {
    console.error("Error al obtener planillas:", error);
  }

  window.sessionStorage.setItem("cargaSeleccionada", this.cargaSeleccionada);
  window.sessionStorage.setItem("tipoObsSeleccionado", this.tipoObsSeleccionado);
  window.sessionStorage.setItem("filtroEstado", this.filtroEstado);
  window.sessionStorage.setItem("filtroRevisado", this.filtroRevisado);
  window.sessionStorage.setItem("filtrosColumna", JSON.stringify(this.filtros));
},
    verObservaciones(planilla) {
      window.sessionStorage.setItem("planillaSeleccionada", JSON.stringify(planilla));
      const params = {
        p_idplanilla: planilla.idPlanilla,
        p_observaciontipo: this.tipoObsSeleccionado,
      };
      if (planilla.nivel === "PLANILLA") {
        params.p_idplaobs = planilla.idRegistro;
      } else {
        params.p_idpladetobs = planilla.idRegistro;
      }
      this.$router.push({
        name: planilla.nivel === "PLANILLA" ? "PlaObsFormR" : "PlaDetObsFormR",
        params,
      });
    },
    cargarSemanasDelMes() {
      api.get(`/vwcargas/activas-por-tramite/${this.p_idTramite}`)
        .then(resp => { this.cargas = resp.data; });
    },
limpiarFiltros() {
  this.filtros = {
    numero: '',
    codigoElemento: '',
    observacionEstandar: '',
    observacionComplementaria: '',
  };
  window.sessionStorage.removeItem("filtrosColumna");
  this.aplicarPaginacion(1);
},
guardarFiltrosColumna() {
  window.sessionStorage.setItem("filtrosColumna", JSON.stringify(this.filtros));
  this.aplicarPaginacion(1);
},

  decodificarTipoObs(tipo) {
    if (tipo === "D") return "Documental";
    if (tipo === "M") return "Médico";
    return tipo || "";
  },

  filasParaExcel(datos) {
    return datos.map((item) => ({
      "Tipo":                        this.decodificarTipoObs(item.tipo),
      "Nivel":                       item.nivel,
      "Número":                      item.numero,
      "Cédula":                      item.cedula,
      "Nombre":                      item.nombre,
      "Código":                      item.codigoElemento,
      "Nombre elemento":             item.nombreElemento,
      "Observación estándar":        item.observacionEstandar,
      "Observación complementaria":  item.observacionComplementaria,
      "Respuesta estándar":          item.respuestaEstandar,
      "Respuesta complementaria":    item.respuestaComplementaria,
      "Estado":                      item.idRespuesta ? "Respondido" : "Pendiente",
      "Justificado":                 item.revisado === 1 ? "Sí" : "No",
    }));
  },

  descargarExcel(filas, nombreArchivo) {
    const hoja = XLSX.utils.json_to_sheet(filas);
    hoja["!cols"] = [
      { wch: 12 }, // Tipo
      { wch: 10 }, // Nivel
      { wch: 12 }, // Número
      { wch: 14 }, // Cédula
      { wch: 30 }, // Nombre
      { wch: 12 }, // Código
      { wch: 25 }, // Nombre elemento
      { wch: 35 }, // Observación estándar
      { wch: 35 }, // Observación complementaria
      { wch: 35 }, // Respuesta estándar
      { wch: 35 }, // Respuesta complementaria
      { wch: 12 }, // Estado
      { wch: 12 }, // Justificado
    ];
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Observaciones");
    XLSX.writeFile(libro, nombreArchivo);
  },

  // Exporta lo que está filtrado/ordenado en pantalla (todas las páginas, no solo la actual)
  exportarVistaActual() {
    if (this.planillasOrdenadas.length === 0) {
      Swal.fire("Aviso", "No hay registros para exportar", "info");
      return;
    }
    const filas = this.filasParaExcel(this.planillasOrdenadas);
    const nombreArchivo = `observaciones_tramite_${this.p_idTramite}_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    this.descargarExcel(filas, nombreArchivo);
  },

  // Exporta TODAS las observaciones del trámite, sin importar los filtros de pantalla
  async exportarTodasObservaciones() {
    this.exportandoTodas = true;
    try {
      Swal.fire({
        title: "Generando reporte...",
        text: "Por favor espera mientras se recuperan todas las observaciones.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await api.get(`/vwobservaciones/tramite/${this.p_idTramite}`);
      const datos = response.data || [];

      Swal.close();

      if (datos.length === 0) {
        Swal.fire("Aviso", "No se encontraron observaciones para este trámite", "info");
        return;
      }

      const filas = this.filasParaExcel(datos);
      const nombreArchivo = `observaciones_completas_tramite_${this.p_idTramite}_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      this.descargarExcel(filas, nombreArchivo);
    } catch (error) {
      Swal.close();
      console.error("Error al exportar observaciones:", error);
      Swal.fire("Error", "No se pudo generar el reporte de observaciones", "error");
    } finally {
      this.exportandoTodas = false;
    }
  },
  
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
thead tr:nth-child(2) th {
  background-color: #2c3e50;
  padding: 4px 6px;
}

thead tr:nth-child(2) input {
  background-color: #fff;
  border: none;
}
</style>